import apiClient from "./../interceptor";

export const auth = {
  login: async (credentials) => {
    const response = await apiClient.post("/login?platform=0", credentials);
    return response.data;
  },
  logout: async () => {
    const response = await apiClient.post("/admin/logout");
    return response.data;
  },
};

